


import React from 'react'
import RadioButtonWrapper from '../../forms/fields/RadioButtonWrapper'
import RadioButtonGroup from '../../forms/fields/RadioButtonGroup'
import Translation from '../../Translation/cont/Translation'


const ItemPerfomancesRadioButton = ({
    id,
    name,
    value,
    currentValue,
    label,
    onChange
}) => {
    return (
        <RadioButtonWrapper id={id} label={label}>
            <input
                name={name}
                id={id}
                type="radio"
                value={value}
                checked={currentValue === value}
                onChange={() => onChange(value)}
                className='radio-button'
            />
        </RadioButtonWrapper>
    )
}

const ItemPerfomancesButtonGroup = ({
    transIdDescription,
    buttonsConfig,
    dataKey,
    itemData,
    onUpdate
}) => {
    const onSetItem = value => {
        if(itemData[dataKey] !== value) {
            onUpdate({
                ... itemData,
                [dataKey]: value
            })
        }
    }

    return (
        <RadioButtonGroup
            description={<Translation id={transIdDescription}/>}
            className={'input-' + dataKey}
        >
            {buttonsConfig.map(button => {
                const buttonId = itemData.id + button.value
                
                return (
                    <ItemPerfomancesRadioButton
                        key={buttonId}
                        id={buttonId}
                        name={itemData.id + dataKey}
                        value={button.value}
                        currentValue={itemData[dataKey]}
                        label={<Translation id={button.transId}/>}
                        onChange={onSetItem}
                    />
                )
            })}
        </RadioButtonGroup>
    )
}

ListItemMoviePerformancesEditButton

const ListItemMoviePerformancesEditButton = ({itemData, onUpdate}) => {
    return (
        <div className="item-edit">
            <div className="item-edit-inner">

                {'extended' === itemData.style && <ItemPerfomancesButtonGroup
                    dataKey='description'
                    transIdDescription="print_flyer_movie_description"
                    itemData={itemData}
                    onUpdate={onUpdate}
                    buttonsConfig={[
                        {
                            "value": "short",
                            "transId": "print_flyer_movie_description_short"
                        }, 
                        {
                            "value": "long",
                            "transId": "print_flyer_movie_description_long"
                        }
                    ]}
                />}

                <ItemPerfomancesButtonGroup
                    dataKey='style'
                    transIdDescription="print_flyer_movie_style"
                    itemData={itemData}
                    onUpdate={onUpdate}
                    buttonsConfig={[
                        {
                            "value":"compact",
                            "transId": "print_flyer_movie_style_compact"
                        }, 
                        {
                            "value":"extended",
                            "transId": "print_flyer_movie_style_extended"
                        }
                    ]}
                />

            </div>
        </div>
    )
}

export default ListItemMoviePerformancesEditButton